import { attempt } from 'lodash-es';
import parseEscapeData from './parseEscapeData';

export const getCartInitData = () => {
  const rawCartData = document.getElementById('sl-cart-init-data')?.textContent;

  if (!rawCartData) {
    return null;
  }

  return attempt(parseEscapeData, rawCartData);
};
